var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "14",
        viewBox: "0 0 16 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.99967 13C12.4184 13 15.9997 10.0906 15.9997 6.5C15.9997 2.90937 12.4184 0 7.99967 0C3.58092 0 -0.00032957 2.90937 -0.00032957 6.5C-0.00032957 7.90938 0.552795 9.2125 1.4903 10.2781C1.43092 11.0437 1.13405 11.725 0.821545 12.2437C0.64967 12.5312 0.47467 12.7625 0.346545 12.9187C0.28092 12.9969 0.23092 13.0563 0.19342 13.0969C0.17467 13.1156 0.16217 13.1313 0.152795 13.1406L0.14342 13.15C-0.000329569 13.2937 -0.0409546 13.5063 0.0371704 13.6938C0.115295 13.8813 0.296545 14.0031 0.49967 14.0031C1.39655 14.0031 2.29967 13.725 3.04967 13.4C3.7653 13.0875 4.37467 12.7156 4.74655 12.4438C5.7403 12.8031 6.84029 13.0031 7.99967 13.0031V13ZM3.99967 5.5C4.26489 5.5 4.51924 5.60536 4.70678 5.79289C4.89431 5.98043 4.99967 6.23478 4.99967 6.5C4.99967 6.76522 4.89431 7.01957 4.70678 7.20711C4.51924 7.39464 4.26489 7.5 3.99967 7.5C3.73445 7.5 3.4801 7.39464 3.29256 7.20711C3.10503 7.01957 2.99967 6.76522 2.99967 6.5C2.99967 6.23478 3.10503 5.98043 3.29256 5.79289C3.4801 5.60536 3.73445 5.5 3.99967 5.5ZM7.99967 5.5C8.26489 5.5 8.51924 5.60536 8.70678 5.79289C8.89431 5.98043 8.99967 6.23478 8.99967 6.5C8.99967 6.76522 8.89431 7.01957 8.70678 7.20711C8.51924 7.39464 8.26489 7.5 7.99967 7.5C7.73445 7.5 7.4801 7.39464 7.29256 7.20711C7.10503 7.01957 6.99967 6.76522 6.99967 6.5C6.99967 6.23478 7.10503 5.98043 7.29256 5.79289C7.4801 5.60536 7.73445 5.5 7.99967 5.5ZM10.9997 6.5C10.9997 6.23478 11.105 5.98043 11.2926 5.79289C11.4801 5.60536 11.7345 5.5 11.9997 5.5C12.2649 5.5 12.5192 5.60536 12.7068 5.79289C12.8943 5.98043 12.9997 6.23478 12.9997 6.5C12.9997 6.76522 12.8943 7.01957 12.7068 7.20711C12.5192 7.39464 12.2649 7.5 11.9997 7.5C11.7345 7.5 11.4801 7.39464 11.2926 7.20711C11.105 7.01957 10.9997 6.76522 10.9997 6.5Z",
          fill: "black",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }